import React from "react";
import PropTypes from "prop-types";
import { track } from "../../../../analytics/facade.js";

const UpsellItemLabel = (props) => (
  <p className="UpsellItemLabel">
    <strong>{props.title}</strong>
    <span>{props.price}</span>
  </p>
);

UpsellItemLabel.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
};

export const remapAddons = (props) =>
  props.availableAddons.map((addon) => {
    const defaultChecked = !!props.item.components.find(
      (c) => c.id === addon.id
    );
    return {
      className: "UpsellItems__checkbox",
      label: (
        <UpsellItemLabel
          title={addon.titleInCartUpsell || addon.title}
          price={addon.price.formatted}
        />
      ),
      id: `${props.item.id}_${addon.id}_${addon.type}`,
      name: `${props.item.id}_${addon.id}_${addon.type}`,
      defaultChecked,
      value: addon.id,
      onChange: (v) => {
        track("Add on Upsell", {
          category: props.item.productSku,
          action: "Cart giftwrap upsell",
          label: props.item.giftWrap ? "Remove" : "Add",
        });
        props.handleEditAddon(props.item, props.countryModel, addon);
      },
    };
  });
